import axios from "axios";

const API = "http://127.0.0.1:8000/api/hospitals/";

function unwrapResponse(res) {
  const data = res?.data;
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  return [];
}

export async function listHospitals() {
  const res = await axios.get(API);
  return unwrapResponse(res);
}